/**
 * abtunes.com (and www) is the landing page, always, logged in or not.
 * admin.abtunes.com is the admin. Everything else (app.abtunes.com,
 * localhost, the Amplify preview URL) is the player app, with the admin
 * also reachable at /admin for local development.
 */
const LANDING_HOSTS = ['abtunes.com', 'www.abtunes.com'];

export const APP_ORIGIN = process.env.REACT_APP_APP_ORIGIN || 'https://app.abtunes.com';

export const isLandingHost = () => LANDING_HOSTS.includes(window.location.hostname);

export const isAdminHost = () => window.location.hostname.startsWith('admin.');
